import React from 'react';
import './MyBookingQRModal.css';

export default function MyBookingQRModal({ show, onClose }) {
  if (!show) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('qr-modal-overlay')) {
      onClose();
    }
  };

  return (
    <div className="qr-modal-overlay" onClick={handleOverlayClick}>
      <div className="qr-modal">
        <h3 className="qr-title">Scan For Event Details</h3>
        <div className="qr-box">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=YourEventURLHere"
            alt="QR Code"
            className="qr-image"
          />
        </div>
      </div>
    </div>
  );
}
